{
  "main": {
    "title": "Documentazione dei compiti",
    "nazaj": "Indietro"
  },
  "stevilcni": {
    "vsiD": "Tutti i documenti",
    "vsiN1": "Tutti",
    "vsiN2": "NON",
    "vsiN3": "-documenti approvati",
    "vsiP": "Tutti i compiti approvati",
    "vsiZ": "Tutti i compiti respinti"
  },
  "potrjevanje": {
    "odobri": "Approva",
    "zavrni": "Rifiuta",
    "naloge": "compiti",
    "datum": "Data",
    "poslal": "Inviato da",
    "odobreni": "approvati",
    "nalogi": "compiti",
    "zavrnjeni": "respinti"
  },
  "table": {
    "nalogiTitle": "Documentazione dei compiti"
  },
  "modal": {
    "opomba": "Nota: Perché sto rifiutando il documento!"
  },
  "buttons": {
    "stevilcni": "Panoramica numerica",
    "zapriPregled": "Chiudi panoramica",
    "zavrniDokument": "Rifiuta documento",
    "potrdiDokument": "Approva documento"
  }
}